<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="Registers"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpBox
      direction="column"
    >
      <ItpBox
        v-if="items.length"
      >
        <ItpFormSelect2
          name="register"
          v-model="selectedRegister"
          bind-object
          valueField="id"
          textField="name"
          :options="items"
          class="w-50"
        >
        </ItpFormSelect2>
        <DIV
          class="ml-3"
        >
          <ItpButton
            :text="'Add register...'|pgettext('Registers')"
            @click.prevent.stop="evh_3054425420812800_clickPreventStop($event, {})"
          >
          </ItpButton>
        </DIV>
      </ItpBox>
      <ItpBox
        direction="column"
        alignItems="center"
        v-if="items.length === 0 && !createRegister"
      >
        <p>
          {{ 'No registers have been added yet.'|pgettext('Registers') }}
        </p>
        <ItpButton
          variant="primary"
          :text="'Create register...'|pgettext('Registers')"
          @click.prevent.stop="evh_814138253067422_clickPreventStop($event, {})"
        >
        </ItpButton>
      </ItpBox>
      <hr
        class="w-100"
        v-if="createRegister || selectedRegister"
      >
      </hr>
      <UcRegister
        :oid="createRegister ? null : selectedRegister.id"
        v-if="createRegister || selectedRegister"
        @saved="evh_3774018224472797_saved($event, {})"
        @deleted="evh_3774018224472797_deleted($event, {})"
      >
      </UcRegister>
    </ItpBox>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :text="'Close'|gettext"
      variant="default"
      @click.prevent.stop="evh_1548630417156826_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "settings.registers",
    path: "registers",
    component: "Registers"
  }
)

@Component()
export default class Registers extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  onRegisterSaved(...args: any[]) {
    const data = args[0]
    const idx = _.findIndex(this.items, { id: data.id })

    if (idx == -1) {
      this.items.push(data);
    }
    else {
      this.items[idx] = data;
    }
    this.selectedRegister = data;
    this.createRegister = false;
  }

  onRegisterDeleted(...args: any[]) {
    const data = args[0]
    _.remove(this.items, { id: data.id })

    if (this.previousSelectionId) {
      const match = _.find(this.items, { id: this.previousSelectionId });
      if (match) {
        this.selectedRegister = match;
      }
    }

    if (this.items.length) {
      this.selectedRegister = this.items[0];
    }
    else {
      this.selectedRegister = null;
    }

    this.previousSelectionId = null;
    this.createRegister = false;
  }

  @Prop({
    type: String,
    default: "lg",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  items!: any;

  async $$load_items() {
    return this.$fn.fetch('list_register')
  }

  selectedRegister!: any;

  async $$load_selectedRegister() {
    return this.items.length ? this.items[0] : null
  }

  previousSelectionId!: any;
  createRegister!: any;
  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['items', 'selectedRegister', 'previousSelectionId', 'createRegister', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        items: null,
        selectedRegister: null,
        previousSelectionId: null,
        createRegister: false,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "lg",
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.pgettext("Registers|Title", "Configure registers"),
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_4278_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_4278, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_3054425420812800_script_4282_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_3054425420812800_script_4282, alias=addRegister
    (
      this.createRegister = true,
      this.previousSelectionId = this.selectedRegister?.id,
      this.selectedRegister = null
    )
  }

  async act_3054425420812800_script_4282_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_3054425420812800_script_4282, alias=addRegister
    return {
      value: () => this.act_3054425420812800_script_4282_getActionArgs_value($event),
    }
  }

  async evh_3054425420812800_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3054425420812800_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_814138253067422_script_4284_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_814138253067422_script_4284, alias=addRegister
    (
      this.createRegister = true,
      this.previousSelectionId = this.selectedRegister?.id,
      this.selectedRegister = null
    )
  }

  async act_814138253067422_script_4284_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_814138253067422_script_4284, alias=addRegister
    return {
      value: () => this.act_814138253067422_script_4284_getActionArgs_value($event),
    }
  }

  async evh_814138253067422_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_814138253067422_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_3774018224472797_script_4286_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_3774018224472797_script_4286, alias=undefined
    this.onRegisterSaved($event.data)
  }

  async act_3774018224472797_script_4286_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_3774018224472797_script_4286, alias=undefined
    return {
      value: () => this.act_3774018224472797_script_4286_getActionArgs_value($event),
    }
  }

  async evh_3774018224472797_saved(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3774018224472797_saved.executeFromDOM(this, event, scope);
  }

  async act_3774018224472797_script_4288_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_3774018224472797_script_4288, alias=undefined
    this.onRegisterDeleted($event.data)
  }

  async act_3774018224472797_script_4288_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_3774018224472797_script_4288, alias=undefined
    return {
      value: () => this.act_3774018224472797_script_4288_getActionArgs_value($event),
    }
  }

  async evh_3774018224472797_deleted(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3774018224472797_deleted.executeFromDOM(this, event, scope);
  }

  async evh_1548630417156826_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1548630417156826_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_4278: actions.CloseModalAction;
    evh_7315092382398562_close_4277: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeModal_4280: actions.CloseModalAction;
    evh_2248226175642056_close_4279: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_3054425420812800_script_4282: actions.ScriptAction;
    evh_3054425420812800_clickPreventStop_4281: actions.EventHandlerImpl;
    evh_3054425420812800_clickPreventStop: actions.EventHandlerGroup;
    act_814138253067422_script_4284: actions.ScriptAction;
    evh_814138253067422_clickPreventStop_4283: actions.EventHandlerImpl;
    evh_814138253067422_clickPreventStop: actions.EventHandlerGroup;
    act_3774018224472797_script_4286: actions.ScriptAction;
    evh_3774018224472797_saved_4285: actions.EventHandlerImpl;
    evh_3774018224472797_saved: actions.EventHandlerGroup;
    act_3774018224472797_script_4288: actions.ScriptAction;
    evh_3774018224472797_deleted_4287: actions.EventHandlerImpl;
    evh_3774018224472797_deleted: actions.EventHandlerGroup;
    act_1548630417156826_closeModal_4290: actions.CloseModalAction;
    evh_1548630417156826_clickPreventStop_4289: actions.EventHandlerImpl;
    evh_1548630417156826_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_4278 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_4278_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_4277 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_4278,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_4277],
      }
    );
    const act_2248226175642056_closeModal_4280 = new actions.CloseModalAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_4279 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeModal_4280,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_4279],
      }
    );
    const act_3054425420812800_script_4282 = new actions.ScriptAction(
      {
        actionArgs: this.act_3054425420812800_script_4282_getActionArgs,
        displayName: "addRegister",
        events: [],
      }
    );
    const evh_3054425420812800_clickPreventStop_4281 = new actions.EventHandlerImpl(
      {
        action: act_3054425420812800_script_4282,
        event: "click.prevent.stop",
        displayName: "addRegister",
      }
    );
    const evh_3054425420812800_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_3054425420812800_clickPreventStop_4281],
      }
    );
    const act_814138253067422_script_4284 = new actions.ScriptAction(
      {
        actionArgs: this.act_814138253067422_script_4284_getActionArgs,
        displayName: "addRegister",
        events: [],
      }
    );
    const evh_814138253067422_clickPreventStop_4283 = new actions.EventHandlerImpl(
      {
        action: act_814138253067422_script_4284,
        event: "click.prevent.stop",
        displayName: "addRegister",
      }
    );
    const evh_814138253067422_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_814138253067422_clickPreventStop_4283],
      }
    );
    const act_3774018224472797_script_4286 = new actions.ScriptAction(
      {
        actionArgs: this.act_3774018224472797_script_4286_getActionArgs,
        events: [],
      }
    );
    const evh_3774018224472797_saved_4285 = new actions.EventHandlerImpl(
      {
        action: act_3774018224472797_script_4286,
        event: "saved",
        displayName: "script",
      }
    );
    const evh_3774018224472797_saved = new actions.EventHandlerGroup(
      {
        handlers: [evh_3774018224472797_saved_4285],
      }
    );
    const act_3774018224472797_script_4288 = new actions.ScriptAction(
      {
        actionArgs: this.act_3774018224472797_script_4288_getActionArgs,
        events: [],
      }
    );
    const evh_3774018224472797_deleted_4287 = new actions.EventHandlerImpl(
      {
        action: act_3774018224472797_script_4288,
        event: "deleted",
        displayName: "script",
      }
    );
    const evh_3774018224472797_deleted = new actions.EventHandlerGroup(
      {
        handlers: [evh_3774018224472797_deleted_4287],
      }
    );
    const act_1548630417156826_closeModal_4290 = new actions.CloseModalAction(
      {
        events: [],
      }
    );
    const evh_1548630417156826_clickPreventStop_4289 = new actions.EventHandlerImpl(
      {
        action: act_1548630417156826_closeModal_4290,
        event: "click.prevent.stop",
        displayName: "closeModal",
      }
    );
    const evh_1548630417156826_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1548630417156826_clickPreventStop_4289],
      }
    );
    return {
      act_7315092382398562_closeModal_4278,
      evh_7315092382398562_close_4277,
      evh_7315092382398562_close,
      act_2248226175642056_closeModal_4280,
      evh_2248226175642056_close_4279,
      evh_2248226175642056_close,
      act_3054425420812800_script_4282,
      evh_3054425420812800_clickPreventStop_4281,
      evh_3054425420812800_clickPreventStop,
      act_814138253067422_script_4284,
      evh_814138253067422_clickPreventStop_4283,
      evh_814138253067422_clickPreventStop,
      act_3774018224472797_script_4286,
      evh_3774018224472797_saved_4285,
      evh_3774018224472797_saved,
      act_3774018224472797_script_4288,
      evh_3774018224472797_deleted_4287,
      evh_3774018224472797_deleted,
      act_1548630417156826_closeModal_4290,
      evh_1548630417156826_clickPreventStop_4289,
      evh_1548630417156826_clickPreventStop,
      addRegister: act_814138253067422_script_4284,
    }
  }
}

Vue.component("Registers", Registers);

</script>